module.exports = __webpack_public_path__ + "static/icon-trophy-246ea627e4bd9b4432b574baf6f1d343.png";